
import React, { useEffect, useState } from "react";
import axios from "axios";
import AssetTable from "./AssetTable";

const BASE_URL = process.env.REACT_APP_API_URL;
const ENDPOINT = "/dq-hollistic/asset-details";

const DEFAULT_PAGE = 1;
const DEFAULT_PAGE_SIZE = 10;

const AssetsDetails = ({ filters, setFilters, onFilterOptionsChange }) => {
  const { parentDomain, domain, subDomain, product } = filters;

  const [rows, setRows] = useState([]);
  const [pagination, setPagination] = useState({
    page: DEFAULT_PAGE,
    pageSize: DEFAULT_PAGE_SIZE,
    totalPages: 0,
    totalCount: 0,
  });
  
  const [page, setPage] = useState(DEFAULT_PAGE);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_SIZE);
  const [activeSearchParams, setActiveSearchParams] = useState({});
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [sortBy, setsortBy] = useState(null);
  const [sortTableBy,setsortTableBy] =useState(null)
  const [assetCount, setAssetCount] = useState(0);
  const [columnSearch, setColumnSearch] = useState({
  domain_name: "",
  sub_domain_name: "",
  product_name: "",
  data_asset_name: "",
  execution_date: "",
  frequency: "",
  total_dq_score: "",
  region: "",
});

  const fetchData = async (params = {}) => {
    setLoading(true);
    setError(null);

    try {
  const res = await axios.get(`${BASE_URL}${ENDPOINT}`, {
            params: {
          parentDomain: parentDomain === "All Parent Domains" ? "" : parentDomain,
          domain: domain === "All Domains" ? "" : domain,
          subDomain: subDomain === "All Sub Domains" ? "" : subDomain,
          product: product === "All Products" ? "" : product,
          page,
          pageSize,
            sortBy: sortBy,           
  sortOrder: sortTableBy,
 ...activeSearchParams,          
        },
      });

      setRows(res.data.data || []);
      setPagination(res.data.pagination || pagination);
      setAssetCount(res.data.assetCount || 0);
    
      if (res.data.filters && res.data.filters.parent_domains) {
  if (typeof onFilterOptionsChange === "function") {
    onFilterOptionsChange(res.data.filters.parent_domains);
  }
}
    } catch (err) {
      setError("Failed to fetch data");
    } finally {
      setLoading(false);
    }
  };

const handleColumnSearch = (key, value) => {
  setColumnSearch({ ...columnSearch, [key]: value });
};

const handleSearchSubmit = (key, value) => {
  const newSearchParams = { [key]: value };
  setActiveSearchParams(newSearchParams); 
  setPage(1);
};
const handleReset = () => {
  setColumnSearch({
    domain_name: "",
    sub_domain_name: "",
    product_name: "",
    data_asset_name: "",
    execution_date: "",
    frequency: "",
    total_dq_score: "",
    region: "",
  });
  setActiveSearchParams({});
  setPage(1);
};


  useEffect(() => {
    fetchData();
  }, [parentDomain, domain, subDomain, product, page, pageSize,sortBy, sortTableBy,activeSearchParams]);

  return (
    <div>
     

      <div className="pl-4 pr-4">
        <AssetTable
          tableData={rows}
          loading={loading}
          assetCount={assetCount}
          error={error}
          pagination={pagination}
          onPageChange={(p) => setPage(p)}
           onSearchSubmit={handleSearchSubmit}
            onReset={handleReset} 
           onColumnSearchChange={handleColumnSearch}
  columnSearch={columnSearch}
          onPageSizeChange={(s) => {
            setPageSize(s);
            setPage(1);
          }}
           onSortChange={(column, order) => {  
    setsortBy(column);
    setsortTableBy(order)

  }}
        />
      </div>
    </div>
  );
};

export default AssetsDetails;
